import { memo } from 'react';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { useAppSelector } from '../hooks/redux';
import { useGetHealthQuery } from '../store/slices/apiSlice';

export const HomePage: React.FC = memo(() => {
  const { data: health, isLoading, error } = useGetHealthQuery(undefined, {
    // Skip the query if we're not on the home page for long
    pollingInterval: 0, // Disable polling
    refetchOnMountOrArgChange: false, // Don't refetch on mount if we have data
  });
  const { theme } = useAppSelector(state => state.app);

  return (
    <div className="text-center">
      <h1 className="text-4xl font-bold text-gray-900 mb-4">
        Welcome to Glassshop
      </h1>
      <p className="text-lg text-gray-600 mb-8">
        Modern web application is ready!
      </p>

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold mb-4">System Status</h2>

        {isLoading && (
          <div className="flex justify-center mb-4">
            <LoadingSpinner />
          </div>
        )}

        {error && (
          <p className="text-red-600 mb-4">❌ Backend: Connection failed</p>
        )}

        {health && (
          <>
            <p className="text-green-600">✅ Frontend: Ready</p>
            <p className="text-green-600">
              ✅ Backend: {health.status} (v{health.version})
            </p>
            <p className="text-green-600">✅ Database: {health.database?.status || 'Unknown'}</p>
            <p className="text-green-600">
              ✅ Redux Store: Active (Theme: {theme})
            </p>
          </>
        )}
      </div>
    </div>
  );
});

HomePage.displayName = 'HomePage';
